import React, { useEffect, useRef } from 'react'
import * as THREE from 'three';
import mapCOORDS from '../../../TestData/TestGPX';

const COORDS = mapCOORDS;


const ResultMapCanvas = () => {
    const pointsRef = useRef<THREE.CatmullRomCurve3>(new THREE.CatmullRomCurve3())

    const mountRef = useRef<HTMLDivElement>(null);
    // const pointsRef = useRef(new THREE.CatmullRomCurve3([
    //     // Convert your lat, long, elevation data to THREE.Vector3 instances
    //     // Example:
    //     // new THREE.Vector3(0, 0, 36.32), // These values should be mapped from your actual data
    //     // new THREE.Vector3(1, 0, 35.12),
    //     // ... more points
    // ]));

    const NormalizeCoordinates = () => {
        const latitudes = COORDS.map(coord => coord[0]);
const longitudes = COORDS.map(coord => coord[1]);
const minLat = Math.min(...latitudes);
const maxLat = Math.max(...latitudes);
const minLong = Math.min(...longitudes);
const maxLong = Math.max(...longitudes);
const altitudes = COORDS.map(coord => coord[2]);
const maxAltitude = Math.max(...altitudes);
const altitudeScale = 2; // Adjust this scale factor as needed


// Dimensions of your map box (for example, 500x500 pixels)
const mapWidth = 250;
const mapHeight = 250;

// Normalize and map the coordinates
const normalizedCoordinatesIntern = COORDS.map(coord => {
    const normalizedLat = (coord[0] - minLat) / (maxLat - minLat);
    const normalizedLong = (coord[1] - minLong) / (maxLong - minLong);
    const scaledAltitude = (coord[2] / maxAltitude) * altitudeScale;

    // Map to your box's coordinate system
    const x = normalizedLong * mapWidth;
    const y = (1 - normalizedLat) * mapHeight; // Invert y-axis if necessary

    return [x , y, scaledAltitude]; // x, y, and altitude
});
    return normalizedCoordinatesIntern;
    }


    useEffect(() => {
        const norm = NormalizeCoordinates();
        console.log("Norm",norm);
        const vectorPoints = norm.map(coord => new THREE.Vector3(coord[0], coord[1], coord[2]));
        pointsRef.current = new THREE.CatmullRomCurve3(vectorPoints);

        const scene = new THREE.Scene();
        scene.background = new THREE.Color(0xeeeeee); // Added a background color for visibility

        const camera = new THREE.PerspectiveCamera(95, window.innerWidth / window.innerHeight, 0.1, 1000);
        // camera.rotation.set(0, -90.44, 53.14);
        const rotationInRadians = 90 * Math.PI / 180;

        // const highestAltitude = Math.max(...norm.map(coord => coord[2]));
        // camera.position.set(norm[0][0], highestAltitude + 100, norm[0][2] + 200); // Adjust as needed

        // // Point the camera to look at a point along the path
        // camera.lookAt(new THREE.Vector3(norm[0][0], 0, norm[0][2]));


         camera.position.set(150, 100, 350);
         camera.lookAt(new THREE.Vector3(340, 10, 90)); // Ensure camera is looking at the origin
         camera.rotateOnWorldAxis(new THREE.Vector3(0.7, 0, 0), THREE.MathUtils.degToRad(30));

        const renderer = new THREE.WebGLRenderer();
        renderer.setSize(window.innerWidth, window.innerHeight);
        mountRef.current?.appendChild(renderer.domElement);
        
        const dotGeometry = new THREE.SphereGeometry(10.2, 32, 32);
        const dotMaterial = new THREE.MeshBasicMaterial({ color: 0xff0000 });
        const dot = new THREE.Mesh(dotGeometry, dotMaterial);
        scene.add(dot);

        const curve = new THREE.CatmullRomCurve3(vectorPoints);
        const tubeGeometry = new THREE.TubeGeometry(curve, 20, 1.3, 8, false); // Increased radius for visibility
        const tubeMaterial = new THREE.MeshBasicMaterial({ color: 0x00ff00 });
        const tube = new THREE.Mesh(tubeGeometry, tubeMaterial);
        scene.add(tube);
        
        let progress = 0;

        const animate = () => {
            requestAnimationFrame(animate);
            
            // Update dot position
            const dotPosition = pointsRef.current.getPoint(progress);
            dot.position.set(dotPosition.x, dotPosition.y, dotPosition.z);

            // Increment progress for the dot's movement (adjust speed as needed)
            progress = (progress + 0.001) % 1;
            renderer.render(scene, camera);


        };

        animate();

        return () => {
            mountRef.current?.removeChild(renderer.domElement);
        };
    }, []);

    return <div className='result-map-box' ref={mountRef} />;


}

export default ResultMapCanvas